import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../react-query/queryKeys';
import { getAllArticlesByCategory, GetAllArticlesByCategoryProps } from '../strapi';

export default function useFetchAllArticlesByCategory(
  props: GetAllArticlesByCategoryProps,
  enabled: boolean
) {
  const query = useQuery({
    queryKey: queryKeys.insightsHub.byCategory(props.category, props.projectTypes),
    queryFn: async () => {
      const response = await getAllArticlesByCategory(props);
      return response;
    },
    enabled,
  });

  return query;
}
